import React from 'react';
import { useState, useLayoutEffect } from 'react';

export const useHandleAccordion = ({ defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleToggle = () => {
    setIsOpen(state => !state);
  };

  useLayoutEffect(() => {
    if (defaultOpen) {
      setIsOpen(true);
    }
  }, [defaultOpen]);

  return { isOpen, handleClose, handleOpen, setIsOpen, handleToggle };
};
